<template>
  <div id="app">
    <!-- 以下两种效果任选其一 -->
    <!-- <Transition name="slide-fade"> -->
    <!-- <Transition name="fade" mode="out-in">
      <router-view />
    </transition> -->
    <keep-alive :exclude="['TourGjz', 'TourCAWSmart']" include="MaintainInfo">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </keep-alive>
  </div>
</template>

<script>
import MainMenu from "@/components/MainMenu.vue";
import TourScene from "@/components/TourScene.vue";
import MaintainInfo from "@/components/MaintainInfo.vue";
import AboutUs from "@/components/AboutUs.vue";
export default {
  name: 'App',
  components: {
    MainMenu,
    TourScene,
    MaintainInfo,
    AboutUs
  },
  mounted() {
    this.preloadComponent("MainMenu");
    this.preloadComponent("TourScene");
    this.preloadComponent("MaintainInfo");
    this.preloadComponent("AboutUs");
  },
  methods: {
    preloadComponent(component) {
      console.log(`开始预加载${component}组件`);
      import(`@/components/${component}.vue`).then(() => {
        console.log(`${component}组件预加载成功`);
      }).catch((error) => {
        console.log(`${component}组件预加载失败，错误信息：${error}`);
      });
    }
  }
}
</script>

<style lang="css" src="./assets/common.css"></style>
<style scoped>
/* 以下两种效果任选其一 */
/* 幻灯片效果 */
/* .slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
div {
  background-color: black;
} */
/* fade效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

#app {
  width: 102.4rem;
  height: 57.6rem;
  background: url(./assets/img/MasterDDSSlicePNGe4d93d0ed3915930e4fa3507b05af898.jpg) 100% no-repeat;
  background-size: 100% 100%;
  /* z-index: -2; */
}

@media (max-width: 800px) {
  #app {
    background: none;
  }
}
</style>